import React from 'react';


function MethodologyPage() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-8">
        <h1 className="text-2xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Methodology</h1>

        <section className="mb-10">
          <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Design Principles</h2>
          <div className="space-y-4 text-sm text-gray-800">
            <div className="border-l-2 border-[#E2E8F0] pl-4">
              <h3 className="font-semibold text-[#102A43]">Repeatability</h3>
              <p>Procedures must produce consistent results independent of the practitioner. Standards define specific data collection methods and decision criteria to minimize subjectivity.</p>
            </div>
            <div className="border-l-2 border-[#E2E8F0] pl-4">
              <h3 className="font-semibold text-[#102A43]">Conservative Estimation</h3>
              <p>Methodologies default to underestimation when data is incomplete. This principle mitigates risk of inflated projections and supports reliable planning.</p>
            </div>
            <div className="border-l-2 border-[#E2E8F0] pl-4">
              <h3 className="font-semibold text-[#102A43]">Neutrality</h3>
              <p>Standards are platform-agnostic. Measurement focuses on observed inputs and outcomes, not technical architecture.</p>
            </div>
            <div className="border-l-2 border-[#E2E8F0] pl-4">
              <h3 className="font-semibold text-[#102A43]">Versioning</h3>
              <p>Revisions are maintained as distinct documents. Published standards are immutable.</p>
            </div>
          </div>
        </section>

        <section className="mb-10">
          <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Rationale for Conservatism</h2>
          <p className="text-sm text-gray-800 mb-3">
            The AI market exhibits frequent disparity between claimed capabilities and observed performance. Conservative assumptions address:
          </p>
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-800">
            <li>Implementation risk and failure rates.</li>
            <li>Data quality variability.</li>
            <li>Integration complexity.</li>
            <li>Workflow stability issues.</li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Exclusion of Speculative Metrics</h2>
          <p className="text-sm text-gray-800 mb-3">
            Standards exclude metrics that cannot be directly observed or quantified with repeatability. Excluded categories:
          </p>
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-800">
            <li>Projected revenue lift (soft benefits).</li>
            <li>Estimated competitive advantage.</li>
            <li>Hypothetical avoided costs.</li>
            <li>Strategic "option value".</li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Interpretation Guidance</h2>
          <p className="text-sm text-gray-800">
            Results indicate direct, measurable impact only. Low ROI or readiness scores reflect operational realities, not necessarily strategic invalidity. Users should evaluate results as baseline data points rather than comprehensive value assessments.
          </p>
        </section>
      </div>
    </>
  );
}

export default MethodologyPage;